<template>
  <div class="view-community">
    <page-header />

    <div class="px-4 px-lg-5">
      <div class="row">
        <div class="col-lg-3 col-sm-6 py-5 order-lg-1">
          <categories-list />
        </div>

        <div class="col-lg-3 col-sm-6 py-5 order-lg-3">
          <button
            class="btn btn-primary btn-block btn-strong rounded-pill"
            @click="addDialog = true"
          >
            <i class="fas fa-plus"></i> CRIAR TÓPICO
          </button>

          <top-comments />
          <hr class="my-4" style="border-color: rgba(255, 255, 255, 0.2);" />
          <search-users />
        </div>

        <div class="col-lg-6 py-5 order-lg-2">
          <action-dispatcher
            action="community/getAll"
            :parameters="params"
            ref="commentsGet"
            :always-show-slot="!firstLoad"
            class="my-n4"
            @success="firstLoad = false"
          >
            <comment
              v-for="comment in comments"
              :key="comment.id"
              :comment="comment"
              link
              class="my-4"
              @edit="openEdit"
              @remove="openRemove"
              @reply="reply"
            />

            <div v-if="count === 0" class="my-4 text-light">
              Nenhum tópico aqui
            </div>
          </action-dispatcher>

          <div v-if="count > comments.length" class="text-center pt-4">
            <button class="btn btn-load-more rounded-pill" @click="loadMore">
              VER MAIS
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="addDialog" hide-header hide-footer centered>
      <comments-form key="a" @success="refresh(true)" />
    </b-modal>

    <b-modal v-model="replyDialog" hide-header hide-footer centered>
      <comments-form
        key="b"
        @success="
          $router.push({
            name: 'community-topic',
            params: { id: selectedComment.id }
          })
        "
        :parent="selectedComment"
      />
    </b-modal>

    <b-modal v-model="editDialog" hide-header hide-footer centered>
      <comments-form
        key="c"
        @success="refresh(true)"
        :comment="selectedComment"
      />
    </b-modal>

    <confirmation
      v-model="removeDialog"
      @confirm="remove"
      text="Tem certeza que deseja remover comentário?"
      confirm-button-text="Remover"
    />
  </div>
</template>

<script>
import Comment from "@/components/community/Comment";
import CommentsForm from "@/components/community/CommentsForm";
import TopComments from "@/components/community/TopComments";
import SearchUsers from "@/components/community/SearchUsers";
import CategoriesList from "@/components/community/CategoriesList";
import PageHeader from "@/components/community/PageHeader";
import { mapState } from "vuex";

export default {
  components: {
    CommentsForm,
    Comment,
    TopComments,
    SearchUsers,
    CategoriesList,
    PageHeader
  },
  data() {
    return {
      firstLoad: true,
      addDialog: false,
      replyDialog: false,
      params: {
        offset: 0,
        limit: 10,
        category_id: this.$route.query.category || ""
      },
      selectedComment: null,
      editDialog: false,
      removeDialog: false
    };
  },
  computed: {
    ...mapState("community", ["comments", "count"])
  },
  beforeMount() {
    this.$store.dispatch("community/reset");
  },
  methods: {
    reply(comment) {
      this.selectedComment = comment;
      this.replyDialog = true;
    },
    remove() {
      this.$store
        .dispatch("community/remove", this.selectedComment.id)
        .then(() => {
          this.$message.success("Comentário removido com sucesso");
          setTimeout(() => {
            this.refresh(true);
          }, 1999);
        })
        .catch(() => {
          this.$message.error("Erro");
        });
    },
    openEdit(comment) {
      this.editDialog = true;
      this.selectedComment = comment;
    },
    openRemove(comment) {
      this.removeDialog = true;
      this.selectedComment = comment;
    },
    refresh(reset = false) {
      if (reset) {
        this.$store.dispatch("community/reset");
        this.firstLoad = true;
      }
      this.addDialog = false;
      this.editDialog = false;
      this.replyDialog = false;
      setTimeout(
        () => {
          this.$refs.commentsGet.dispatch();
          if (this.refreshTopComments) {
            // CommunityTopic
            this.refreshTopComments();
          }
        },
        reset ? 1999 : 1
      );
    },
    loadMore() {
      this.params.offset += this.params.limit;
      setTimeout(() => {
        this.refresh();
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-community {
  .btn-load-more {
    font-size: 14px;
    line-height: 21px;
    padding: 10px 32px;
    font-weight: 500;
    background: #1c1c1c;
    color: white;

    &:hover {
      background: #191919;
    }
  }
}
</style>
